import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatVP } from '../../../helpers/helperFunctions';
import { CaptionText } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';

export const DirectRootTeamMemberInfo = () => {
  const { t } = useTranslation('myTeam');

  const { directTeamMemberInfo } = useSelector(
    (store) => store.myTeamBackoffice
  );

  return (
    <>
      <CaptionText center color={color.colors.neutral400} mbSM='12'>
        {t('country')}:{' '}
        <CaptionText bold inline color={color.colors.secondary100}>
          {directTeamMemberInfo?.country
            ? directTeamMemberInfo?.country
            : directTeamMemberInfo?.country ?? '-'}
        </CaptionText>
      </CaptionText>

      <CaptionText center color={color.colors.neutral400} mbSM='12'>
        {t('sponsor')}:{' '}
        <CaptionText bold inline color={color.colors.secondary100}>
          {directTeamMemberInfo?.referrerUser ? (
            <span>
              {`${directTeamMemberInfo?.referrerUser?.username}`} (#
              {directTeamMemberInfo?.referrerUser?.id})
            </span>
          ) : (
            '-'
          )}
        </CaptionText>
      </CaptionText>
      <CaptionText
        center
        color={color.colors.neutral400}
        mbSM='12'
        mobile={true}>
        {t('direct_volume')}:{' '}
        <CaptionText bold inline color={color.colors.secondary100}>
          {formatVP(directTeamMemberInfo?.directTotalVolume)} VP
        </CaptionText>
      </CaptionText>
    </>
  );
};
